<template>
  <BaseView class="index-container">
    <div slot="contantView" class="content">
      <div class="index-panel">
        <div class="nav-panel">
          <HeaderView :active-index="2" />
          <img src="../assets/spsc/services/navBg.png" class="navImg"/>
        </div>
        <section class="nav-section">
          <div class="nav-info">
            <div class="nav-main-text" @click="goGoalPage('/')">Home</div>
            <div class="nav-arrow">></div>
            <div class="nav-sub-text" @click="goGoalPage('/services')">Service&Projects</div>
            <div class="nav-arrow">></div>
            <div class="nav-sub-text" @click="goGoalPage('/projects')">{{ picInfo.name }}</div>
          </div>
          <div class="nav-line"></div>
        </section>
        <section class="content-panel">
          <div class="projects-pic-group">
            <div class="main-img-group">
              <div class="pre-btn" @click="mainImgLeft()"></div>
              <div class="big-pic-group">
                <img :src="mainPicUrl" class="main-pic" />
              </div>
              <div class="next-btn" @click="mainImgRight()"></div>
            </div>
            <div class="pic-name">{{ mainName }}</div>
            <div class="pic-group">
              <div class="pre-btn" @click="imgLeft()"></div>
              <ul :class="[picInfo.picList.length > 8 ? 'pic-list' : 'pic-list1']">
                <li class="pic-item" :style="imgStyle" v-for="(item, index) in picInfo.picList" :key="item.id" @click="changePic(item, index)">
                  <img :src="item.imgUrl" :class="index === imgActiveIndex ? 'img-active' : 'img-normal'" />
                </li>
              </ul>
              <div class="next-btn" @click="imgRight()"></div>
            </div>
          </div>
        </section>
        <FooterView />
      </div>
    </div>
  </BaseView>
</template>

<script>
import BaseView from '@/components/BaseView.vue'
import HeaderView from '@/components/HeaderView.vue'
import FooterView from '@/components/FooterView.vue'
import utils from '../utils/util'
const { getQueryString } = utils

export default {
  name: '',
  props: {

  },
  components: {
    BaseView,
    HeaderView,
    FooterView
  },
  data () {
    return {
      mainPicUrl: require('../assets/spsc/projects/1/AluminumAlloyBridge.png'),
      mainName: 'Aluminum alloy bridge',
      imgActiveIndex: 0,
      imgDistance: 0,
      allDistance:0,
      picInfo: {
        id: 1,
        name: 'Civic Building',
        picList: [{
          id: 11,
          text: 'Aluminum alloy bridge',
          imgUrl: require('../assets/spsc/projects/1/AluminumAlloyBridge.png')
        }, {
          id: 12,
          text: 'Concrete',
          imgUrl: require('../assets/spsc/projects/1/Concrete.jpg')
        }, {
          id: 13,
          text: 'Formworks',
          imgUrl: require('../assets/spsc/projects/1/Formworks.jpg')
        }, {
          id: 14,
          text: 'Steel bridge',
          imgUrl: require('../assets/spsc/projects/1/SteelBridge1.jpg')
        }, {
          id: 15,
          text: 'Steel bridge',
          imgUrl: require('../assets/spsc/projects/1/SteelBridge2.jpg')
        }, {
          id: 16,
          text: 'Steel bridge',
          imgUrl: require('../assets/spsc/projects/1/SteelBridge3.jpg')
        }, {
          id: 17,
          text: 'Steel bridge',
          imgUrl: require('../assets/spsc/projects/1/SteelBridge4.jpg')
        }, {
          id: 18,
          text: 'Steel bridge support',
          imgUrl: require('../assets/spsc/projects/1/SteelBridgeSupport.jpg')
        }, {
          id: 19,
          text: 'Steel bridge support',
          imgUrl: require('../assets/spsc/projects/1/SteelBridgeSupport1.jpg')
        }, {
          id: 110,
          text: 'Tunnel construction facilities',
          imgUrl: require('../assets/spsc/projects/1/TunnelConstructionFacilities1.jpg')
        }, {
          id: 111,
          text: 'Tunnel construction facilities',
          imgUrl: require('../assets/spsc/projects/1/TunnelConstructionFacilities2.jpg')
        }]
      },

      projects:[{
        id: 1,
        name: 'Civic Building',
        picList: [{
          id: 11,
          text: 'Aluminum alloy bridge',
          imgUrl: require('../assets/spsc/projects/1/AluminumAlloyBridge.png')
        }, {
          id: 12,
          text: 'Concrete',
          imgUrl: require('../assets/spsc/projects/1/Concrete.jpg')
        }, {
          id: 13,
          text: 'Formworks',
          imgUrl: require('../assets/spsc/projects/1/Formworks.jpg')
        }, {
          id: 14,
          text: 'Steel bridge',
          imgUrl: require('../assets/spsc/projects/1/SteelBridge1.jpg')
        }, {
          id: 15,
          text: 'Steel bridge',
          imgUrl: require('../assets/spsc/projects/1/SteelBridge2.jpg')
        }, {
          id: 16,
          text: 'Steel bridge',
          imgUrl: require('../assets/spsc/projects/1/SteelBridge3.jpg')
        }, {
          id: 17,
          text: 'Steel bridge',
          imgUrl: require('../assets/spsc/projects/1/SteelBridge4.jpg')
        }, {
          id: 18,
          text: 'Steel bridge support',
          imgUrl: require('../assets/spsc/projects/1/SteelBridgeSupport.jpg')
        }, {
          id: 19,
          text: 'Steel bridge support',
          imgUrl: require('../assets/spsc/projects/1/SteelBridgeSupport1.jpg')
        }, {
          id: 110,
          text: 'Tunnel construction facilities',
          imgUrl: require('../assets/spsc/projects/1/TunnelConstructionFacilities1.jpg')
        }, {
          id: 111,
          text: 'Tunnel construction facilities',
          imgUrl: require('../assets/spsc/projects/1/TunnelConstructionFacilities2.jpg')
        }]
      }, {
        id: 2,
        name: 'Wharf Engineering Facilities',
        picList: [{
          id: 21,
          text: 'Marine fenders panels',
          imgUrl: require('../assets/spsc/projects/2/MarineFendersPanels.jpg')
        }, {
          id: 22,
          text: 'Marine steel facilities',
          imgUrl: require('../assets/spsc/projects/2/MarineSteelFacilities1.jpg')
        }, {
          id: 23,
          text: 'Marine steel facilities',
          imgUrl: require('../assets/spsc/projects/2/MarineSteelFacilities2.jpg')
        }, {
          id: 24,
          text: 'Marine steel facilities',
          imgUrl: require('../assets/spsc/projects/2/MarineSteelFacilities3.jpg')
        }, {
          id: 25,
          text: 'Marine steel facilities',
          imgUrl: require('../assets/spsc/projects/2/MarineSteelFacilities4.jpg')
        }, {
          id: 26,
          text: 'Marine steel facilities',
          imgUrl: require('../assets/spsc/projects/2/MarineSteelFacilities5.jpg')
        }, {
          id: 27,
          text: 'Other marine equipment',
          imgUrl: require('../assets/spsc/projects/2/OtherMarineEquipment.jpg')
        }, {
          id: 28,
          text: 'Other marine equipment',
          imgUrl: require('../assets/spsc/projects/2/OtherMarineEquipment2.jpg')
        }, {
          id: 29,
          text: 'Pile cap',
          imgUrl: require('../assets/spsc/projects/2/PileCap.jpg')
        }]
      }, {
        id: 3,
        name: 'Mining Equipment&Facilities',
        picList: [{
          id: 31,
          text: 'Copper mine equipment',
          imgUrl: require('../assets/spsc/projects/3/CopperMineEquipment.jpg')
        }, {
          id: 32,
          text: 'Iron mine Equipment',
          imgUrl: require('../assets/spsc/projects/3/IronMineEquipment.jpg')
        }, {
          id: 33,
          text: 'Roller',
          imgUrl: require('../assets/spsc/projects/3/Roller.jpg')
        }, {
          id: 34,
          text: 'Roller',
          imgUrl: require('../assets/spsc/projects/3/Roller1.jpg')
        }, {
          id: 35,
          text: 'Roller',
          imgUrl: require('../assets/spsc/projects/3/Roller2.jpg')
        }, {
          id: 36,
          text: 'Salt mine equipment',
          imgUrl: require('../assets/spsc/projects/3/SaltMineEquipment.jpg')
        }, {
          id: 37,
          text: 'Salt mine equipment',
          imgUrl: require('../assets/spsc/projects/3/SaltMineEquipment1.jpg')
        }]
      }, {
        id: 4,
        name: 'Metal Fabrication And Machining Product',
        picList: [{
          id: 41,
          text: 'Aluminium product',
          imgUrl: require('../assets/spsc/projects/4/AluminiumProduct.jpg')
        }, {
          id: 42,
          text: 'Stainlee steel products',
          imgUrl: require('../assets/spsc/projects/4/StainleeSteelProducts1.jpg')
        }, {
          id: 43,
          text: 'Stainless steel',
          imgUrl: require('../assets/spsc/projects/4/StainlessSteel.jpg')
        }, {
          id: 44,
          text: 'Steel product',
          imgUrl: require('../assets/spsc/projects/4/SteelProducts.png')
        }, {
          id: 45,
          text: 'Steel product',
          imgUrl: require('../assets/spsc/projects/4/SteelProducts2.jpg')
        }, {
          id: 46,
          text: 'Steel product',
          imgUrl: require('../assets/spsc/projects/4/SteelProducts3.jpg')
        }, {
          id: 47,
          text: 'Steel product',
          imgUrl: require('../assets/spsc/projects/4/SteelProduct4.jpg')
        }, {
          id: 48,
          text: 'Steel product',
          imgUrl: require('../assets/spsc/projects/4/SteelProduct5.jpg')
        }, {
          id: 49,
          text: 'Steel product',
          imgUrl: require('../assets/spsc/projects/4/SteelProduct6.jpg')
        }]
      }, {
        id: 5,
        name: 'Piles',
        picList: [{
          id: 51,
          text: 'Piles',
          imgUrl: require('../assets/spsc/projects/5/Piles.jpg')
        }, {
          id: 52,
          text: 'Seamless Piping',
          imgUrl: require('../assets/spsc/projects/5/SeamlessPiping.jpg')
        }, {
          id: 53,
          text: 'Water pipe',
          imgUrl: require('../assets/spsc/projects/5/WaterPipe.png')
        }, {
          id: 54,
          text: 'Welded pipe',
          imgUrl: require('../assets/spsc/projects/5/WeldedPipe.jpg')
        }]
      }, {
        id: 6,
        name: 'New Energy',
        picList: [{
          id: 61,
          text: 'Solar photovoltaic panels',
          imgUrl: require('../assets/spsc/projects/6/SolarPhotovoltaicPanels.jpg')
        }, {
          id: 62,
          text: 'Wind power tower',
          imgUrl: require('../assets/spsc/projects/6/WindPowerTower.jpg')
        }]
      }, {
        id: 7,
        name: 'Vessel And Tank',
        picList: [{
          id: 71,
          text: 'LNG tank',
          imgUrl: require('../assets/spsc/projects/7/LNGtank.jpg')
        }, {
          id: 72,
          text: 'Chimney equipment',
          imgUrl: require('../assets/spsc/projects/7/ChimneyEquipment.jpg')
        }]
      }, {
        id: 8,
        name: 'Hosting Equipment',
        picList: [{
          id: 81,
          text: 'Kling crane',
          imgUrl: require('../assets/spsc/projects/8/KlingCrane.png')
        }, {
          id: 82,
          text: 'Gantry crane',
          imgUrl: require('../assets/spsc/projects/8/GantryCrane.png')
        }, {
          id: 83,
          text: 'Offshore crane',
          imgUrl: require('../assets/spsc/projects/8/OffshoreCrane.jpg')
        }]
      }, {
        id: 9,
        name: 'Steel Tower',
        picList: [{
          id: 91,
          text: 'Electric transmission line tower',
          imgUrl: require('../assets/spsc/projects/9/ElectricTransmissionLineTower.png')
        }, {
          id: 92,
          text: 'Communication steel tower ',
          imgUrl: require('../assets/spsc/projects/9/CommunicationSteelTower.png')
        }]
      }, {
        id: 10,
        name: 'Trading Service',
        picList: [{
          id: 101,
          text: 'Casting',
          imgUrl: require('../assets/spsc/projects/10/Casting.jpg')
        }, {
          id: 102,
          text: 'Malleable 90 elbow',
          imgUrl: require('../assets/spsc/projects/10/Malleable90Elbow.png')
        }, {
          id: 103,
          text: 'Pipe elbow',
          imgUrl: require('../assets/spsc/projects/10/PipeElbow.png')
        }, {
          id: 104,
          text: 'Stainless fasteners',
          imgUrl: require('../assets/spsc/projects/10/StainlessFasteners.jpg')
        }, {
          id: 106,
          text: 'Stainless plates',
          imgUrl: require('../assets/spsc/projects/10/StainlessPlates.jpg')
        }, {
          id: 107,
          text: 'Threaded flange',
          imgUrl: require('../assets/spsc/projects/10/ThreadedFlange.png')
        }]
      }]
    }
  },
  computed: {
    imgStyle() {
      return {
        transform: `translate3d(${this.imgDistance}px, 0, 0)`
      }
    }
  },
  methods: {
    changePic(item, index) {
      this.mainPicUrl = item.imgUrl
      this.mainName = item.text
      this.imgActiveIndex = index
    },

    mainImgLeft() {
      this.imgLeft()
    },
    mainImgRight() {
      this.imgRight()
    },

    imgLeft() {
      if (this.imgActiveIndex > 0) {
        this.imgActiveIndex--
        this.picInfo.picList.forEach((item, index) => {
          if (this.imgActiveIndex === index) {
            this.mainPicUrl = item.imgUrl
            this.mainName = item.text
          }
        })

        if (this.imgActiveIndex >= 4) {
          var index = 0
          const temp = window.setInterval(() => {
            if (index < 33) {
              this.imgDistance += 2
              index++
              return
            } else {
              window.clearInterval(temp)
            }
          }, 10)
        }
      }
    },

    imgRight() {
      if (this.imgActiveIndex < this.picInfo.picList.length - 1) {
        this.imgActiveIndex++
        this.picInfo.picList.forEach((item, index) => {
          if (this.imgActiveIndex === index) {
            this.mainPicUrl = item.imgUrl
            this.mainName = item.text
          }
        })

        if (this.imgActiveIndex >= 5) {
          this.allDistance = -66 * (this.imgActiveIndex - 4)
          var index = 0
          const temp = window.setInterval(() => {
            if (index < 33) {
              this.imgDistance -= 2
              index++
              return
            } else {
              window.clearInterval(temp)
            }
          }, 10)
        }
      } else if (this.imgActiveIndex === this.picInfo.picList.length - 1) {
        this.imgActiveIndex = 0
        const firstItem = this.picInfo.picList[0]
        this.mainPicUrl = firstItem.imgUrl
        this.mainName = firstItem.text
        var index = 0
        const temp = window.setInterval(() => {
          if (index < Math.abs(this.allDistance/2)) {
            this.imgDistance += 2
            index++
            return
          } else {
            window.clearInterval(temp)
          }
        }, 1)
      }
    },
    goGoalPage( pathName) {
      this.$router.replace({ path: pathName})
    }
  },
  created () {
    const projectIndex = getQueryString('projectIndex')
    let activeIndex = projectIndex ? parseInt(projectIndex) : 1
    console.log('=====projectIndex', projectIndex, activeIndex, typeof activeIndex)
    activeIndex = activeIndex - 1
    this.picInfo = this.projects[activeIndex]
    console.log('=====activeIndex', activeIndex, this.picInfo)
    const firstPicItem = this.picInfo.picList[0]
    console.log('=====picInfo', this.picInfo, firstPicItem)
    this.mainPicUrl = firstPicItem.imgUrl
    this.mainName = firstPicItem.text
  }
}
</script>
<style scoped lang="scss">

.index-container {
  background: #FFFFFF;
  width: 100%;
}
.index-panel {
  width: 100%;
  min-width: 1200px;
} 

.nav-panel {
  width: 100%;
  height: 100%;
}

.navImg {
  width: 100%;
  height: auto;
  margin-top: -80px;
}

.nav-section {
  width: 1200px;
  margin: 40px auto 60px auto;
}

.nav-info {
  display: flex;
  justify-content: flex-start;
  justify-items: center;
}

.nav-main-text, .nav-sub-text {
  font-size: 14px;
  color: #333333;
  cursor: pointer;
}

.nav-arrow {
  margin: 0 10px;
}

.nav-line {
  width: 100%;
  height: 1px;
  background: #D8D8D8;
  margin-top: 16px;
}

.content-panel {
  width: 1200px;
  margin: 0 auto 106px auto;
}

.projects-pic-group {
  width: 1100px;
  // height: 900px;
  margin: 0 auto;
}

.main-img-group {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.big-pic-group {
  width: 940px;
  height: auto;
  margin: 0 auto;
}

.main-pic {
  width: 100%;
  display: block;

}

.pic-name {
  font-size: 20px;
  color: #111111;
  line-height: 20px;
  margin: 24px auto 48px auto;
  text-align: center;
}

.pic-group {
  // width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pic-list {
  position: relative;
  display: flex;
  width: 940px;
  height: 104px;
  overflow: hidden;
  list-style: none;
}

.pic-list1 {
  position: relative;
  display: flex;
  // width: 940px;
  height: 104px;
  overflow: hidden;
  list-style: none;
}

.pic-item {
  float: left;
  margin: 0 10px;
  cursor: pointer;
}

.pic-item:first-child {
  margin: 0 10px 0 0;
}

.pic-item:last-child {
  margin: 0 10px 0 0;
}

.img-active {
  width: 100px;
  height: 100px;
  border: 2px solid #FF2828;
}

.img-normal {
  width: 100px;
  height: 100px;
}

.pre-btn {
  width: 40px;
  height: 43px;
  background: url('../assets/spsc/projects/preBtn.png') no-repeat;
  background-size: contain;
  cursor: pointer;
}


.next-btn {
  width: 40px;
  height: 43px;
  background: url('../assets/spsc/projects/nextBtn.png') no-repeat;
  background-size: contain;
  cursor: pointer;
}
</style>